<!-- Page Loader -->
<div class="body {{ themeClass }} {{ smallScreenMenu }} {{ darkClass }}">
  <app-page-loader *ngIf="!isStopLoading"></app-page-loader>

  <div id="wrapper" *ngIf="isStopLoading">
    <app-header
      [showNotifMenu]="showNotifMenu"
      [showToggleMenu]="showToggleMenu"
      (toggleSettingDropMenuEvent)="toggleSettingDropMenu()"
      (toggleNotificationDropMenuEvent)="toggleNotificationDropMenu()"
    ></app-header>

    <app-sidebar
      [sidebarVisible]="sidebarVisible"
      [navTab]="navTab"
      [currentActiveMenu]="currentActiveMenu"
      [currentActiveSubMenu]="currentActiveSubMenu"
      (activeInactiveMenuEvent)="activeInactiveMenu($event)"
    ></app-sidebar>
    <!-- <div
            id="main-content" [ngClass]="sidebarStatus ? '' : 'full-width'"
          > -->
    <div
      id="main-content"
      [ngClass]="{ 'layout-fullwidth': !sidebarService.sidebarVisible }"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
